// Twitter API
import { getAPI, token } from "@/api/params.js";
import { makeJsonRequest, getTimestampedUrl } from "@/api/common.js";

const API_PREFIX = `${getAPI()}/user/socials/twitter`;

/**
 * Request authorization Twitter link from backend
 */
export const authTwitter = async () => {
  const callback = `${window.location.origin}/twitter_auth?token=${token}`;
  const {
    data: { link }
  } = await makeJsonRequest({
    url: `${API_PREFIX}/generate_link?token=${token}`,
    method: "POST",
    data: { callback }
  });

  window.open(link, "_blank").focus();

  /** wait when account will be verified */
  const channel = new BroadcastChannel("wct-twitter-verify");

  return await new Promise(resolve => {
    channel.addEventListener("message", ({ data }) => {
      resolve(data);
    });
  });
};

/**
 * Confirm that access to Twitter account is allowed
 * @param {String} oauthToken Access token
 * @param {String} oauthVerifier OAuth verifier
 */
export const verifyTwitter = async (oauthToken, oauthVerifier) => {
  const verifyUrl = `${API_PREFIX}/verify_token?token=${token}`;
  const { data: userData } = await makeJsonRequest({
    url: verifyUrl,
    method: "PUT",
    data: {
      accessToken: oauthToken,
      verifier: oauthVerifier
    }
  });

  const channel = new BroadcastChannel("wct-twitter-verify");
  channel.postMessage(userData);
};

/**
 * Upload video to Facebook
 * @param {Number} videoId Video ID
 * @param {String} twitterId Social account ID
 * @param {Object} twitterData post text & sharing time
 */
export const shareToTwitter = async (
  videoId,
  twitterId,
  twitterData,
  multistepId
) => {
  const sharePath = `${getAPI()}/video/${videoId}/share/twitter`;
  const shareQueryParams =
    multistepId === undefined
      ? `?clipperTwitterUserId=${twitterId}&token=${token}`
      : `?clipperTwitterUserId=${twitterId}&token=${token}&multistepId=${multistepId}`;
  const shareURL = getTimestampedUrl(
    sharePath + shareQueryParams,
    twitterData.scheduledTime
  );
  await makeJsonRequest({
    url: shareURL,
    method: "POST",
    data: {
      text: twitterData.text
    }
  });
};

/**
 * Get basic Twitter account information
 * @returns account info
 */
export const getTwitterInfo = async accountId => {
  const infoUrl = `${API_PREFIX}/${accountId}/info?token=${token}`;
  const infoResp = await fetch(infoUrl);
  const { success, error, ...data } = await infoResp.json();

  if (!success && success !== undefined) {
    throw new Error(error);
  }

  return data;
};
